// import RepositoryFactory from "@/apis";
// const Transaction = RepositoryFactory.transaction;
import Transaction from "../../apis/transaction";

export default {
  CreateTransaction({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Transaction.create_transaction(payload);
        // commit("CREATE_TRANSACTION", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  UpdateTransaction({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await Transaction.update_transaction(payload);
        // commit("UPDATE_TRANSACTION", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
